import PropTypes from 'prop-types';
import UISideNav from 'UIComponents/nav/UISideNav';
import NavItemRecord from 'settings-ui-nav/utils/NavItem';
import NavItem from 'settings-ui-nav/components/NavItem';
import { jsx as _jsx } from "react/jsx-runtime";
const NavGroup = ({
  config,
  divider,
  onItemClick,
  onOpenClick,
  openItems = {},
  pathname,
  settingsApp,
  track,
  hasStagedChanges
}) => {
  if (config && config.children && config.children.length) {
    return /*#__PURE__*/_jsx(UISideNav, {
      "data-reagan-test": "settings-nav",
      divider: divider,
      headingText: config.label,
      children: config.children.map(childNavItem => {
        return /*#__PURE__*/_jsx(NavItem, {
          defaultOpen: openItems[childNavItem.label],
          navItem: childNavItem,
          onItemClick: onItemClick,
          onOpenClick: onOpenClick,
          pathname: pathname,
          settingsApp: settingsApp,
          title: childNavItem.label,
          track: track,
          hasStagedChanges: hasStagedChanges
        }, childNavItem.label);
      })
    });
  }
  return null;
};

/* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
NavGroup.defaultProps = {
  onItemClick: () => {},
  onOpenClick: () => {},
  openItems: {}
};
NavGroup.propTypes = {
  config: PropTypes.instanceOf(NavItemRecord).isRequired,
  divider: PropTypes.bool,
  onItemClick: PropTypes.func,
  onOpenClick: PropTypes.func,
  openItems: PropTypes.object,
  pathname: PropTypes.string,
  settingsApp: PropTypes.string,
  track: PropTypes.func
};
export default NavGroup;